import { merchantApi } from '@/config/axios'

export interface O2oFinanceDepositVO {
  depositRequired?: number
  depositBalance?: number
  depositFrozen?: number
  depositAvailable?: number
  depositNeedReplenish?: boolean
}

export interface O2oFinanceSummaryVO {
  todayGmv?: number
  todayOrderCount?: number
  weekGmv?: number
  weekOrderCount?: number
  monthGmv?: number
  monthOrderCount?: number
  commissionRate?: number
  monthNetIncome?: number
  pendingSettlementAmount?: number
  deposit?: O2oFinanceDepositVO
  depositReplenishTip?: string
}

export interface O2oFinanceIncomeVO {
  orderId?: number
  orderNo?: string
  serviceName?: string
  providerId?: number
  providerName?: string
  finishTime?: string
  orderAmount?: number
  commissionAmount?: number
  netIncome?: number
  commissionRate?: number
  employeeShareRate?: number
  employeeEarnAmount?: number
  institutionKeepAmount?: number
  snapshot?: boolean
}

export interface O2oEmployeeShareRuleVO {
  id?: number
  institutionId?: number
  catalogServiceId?: number
  serviceName?: string
  shareRate?: number
  version?: number
  institutionDefault?: boolean
  updateTime?: string
}

export function getO2oEmployeeShareList() {
  return merchantApi.get<O2oEmployeeShareRuleVO[]>({ url: '/merchant-api/o2o/employee-share/list' })
}

export function saveO2oEmployeeShare(data: {
  catalogServiceId?: number
  shareRate: number
  remark?: string
}) {
  return merchantApi.put({ url: '/merchant-api/o2o/employee-share/save', data })
}

export function clearO2oEmployeeShareOverride(catalogServiceId: number) {
  return merchantApi.delete({
    url: '/merchant-api/o2o/employee-share/service-override',
    params: { catalogServiceId }
  })
}

export function getO2oMerchantFinanceSummary() {
  return merchantApi.get<O2oFinanceSummaryVO>({ url: '/merchant-api/o2o/finance/summary' })
}

export function getO2oMerchantFinanceIncomePage(params: {
  pageNo: number
  pageSize: number
  orderNo?: string
}) {
  return merchantApi.get<{ list: O2oFinanceIncomeVO[]; total: number }>({
    url: '/merchant-api/o2o/finance/income/page',
    params
  })
}

export interface O2oFinanceDepositRecordVO {
  id?: number
  type?: string
  amount?: number
  balanceAfter?: number
  bizNo?: string
  remark?: string
  createTime?: string
}

export function getO2oMerchantFinanceDepositRecords(params: { pageNo: number; pageSize: number }) {
  return merchantApi.get<{ list: O2oFinanceDepositRecordVO[]; total: number }>({
    url: '/merchant-api/o2o/finance/deposit/records',
    params
  })
}

export function applyO2oMerchantSettlement(data: { amount: number; remark?: string }) {
  return merchantApi.post<number>({
    url: '/merchant-api/o2o/finance/settlement/apply',
    data
  })
}
